import { render } from "./TheProfessionalConsultationView.vue?vue&type=template&id=3cbad73a&scoped=true&ts=true"
import script from "./TheProfessionalConsultationView.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalConsultationView.vue?vue&type=script&lang=ts"

import "./TheProfessionalConsultationView.vue?vue&type=style&index=0&id=3cbad73a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cbad73a"]])

export default __exports__